import { Skeleton } from 'antd'
import styles from './XPhotoBox.module.scss'
import cx from 'classnames'
import { MediaObject } from 'types'
import { MediaRenderer } from '../components/MediaRenderer/MediaRenderer'

interface Props {
  mediaObjects?: MediaObject[]
  imagesLoading?: boolean
  showVideoControls?: boolean
  isActive?: boolean
  isInsertingMedia?: boolean
  isPressable?: boolean
  isGenerating?: boolean
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  onClose?: () => void
}

export const XPhotoBox = ({
  mediaObjects,
  imagesLoading,
  showVideoControls,
  isActive = true,
  isInsertingMedia = false,
  isPressable = true,
  showHoverActionOverlay = false,
  isGenerating = false,
  almanacFileKey,
  onClose,
}: Props) => {
  const isOneImage = mediaObjects?.length === 1

  const getImageLayoutClass = (totalImages: number) => {
    switch (totalImages) {
      case 2:
        return styles.twoImages
      case 3:
        return styles.threeImages
      case 4:
        return styles.fourImages
      default:
        return styles.oneImage
    }
  }

  if (imagesLoading || isInsertingMedia) {
    return (
      <div className={cx(styles.photoBox, { [styles.isOneImage]: isOneImage })}>
        {[...Array(2).keys()].map((imageLoader) => (
          <Skeleton key={imageLoader} className={getImageLayoutClass(2)} active paragraph={{ rows: 1 }} title={false} />
        ))}
      </div>
    )
  }

  if (mediaObjects && mediaObjects.length > 0) {
    return (
      <div className={cx(styles.photoBox, { [styles.isOneImage]: isOneImage })}>
        {mediaObjects.map((mediaObject) => {
          return (
            <div key={mediaObject.id} className={cx(styles.imageContainer, getImageLayoutClass(mediaObjects.length))}>
              <MediaRenderer
                mediaObject={mediaObject}
                alt={'twitter'}
                showVideoControls={showVideoControls}
                isActive={isActive}
                isPressable={isPressable}
                showHoverActionOverlay={showHoverActionOverlay}
                almanacFileKey={almanacFileKey}
                onClose={onClose}
                isGenerating={isGenerating}
              />
            </div>
          )
        })}
      </div>
    )
  }

  return null
}
